import MapTool from './map-tool.vue'

MapTool.install = Vue => Vue.component(MapTool.name, MapTool);
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(MapTool);
}
export default MapTool



// WEBPACK FOOTER //
// ./src/packages/map-tool/index.js